import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Button, Popover } from '@blueprintnyc/bpnyc-common';
import { HeaderButton } from '@blueprintnyc/bpnyc-common-admin';
import { Trash } from '@blueprintnyc/bpnyc-common-admin/dist/icons';

class DeleteButton extends PureComponent {
	handleConfirmDelete = async () => {
		const { socket, route, variables, auth0Token, handleUpdate, handleDelete } = this.props;
		if (handleDelete) handleDelete();
		else {
			socket.emit(route, { ...variables, token: auth0Token });
			if (handleUpdate) handleUpdate();
		}
	};

	render() {
		const {
			buttonProps,
			confirmText = this.props.confirmText
				? this.props.confirmText
				: 'Are you sure you want to delete this item?',
			children,
			style,
			shape,
			header,
			icon,
			placement,
			hoverText,
			onConfirm,
		} = this.props;

		const extraButtonProps = {
			icon: icon === false ? null : <Trash />,
			onClick: e => e.preventDefault(),
			type: 'delete',
		};
		return (
			<Popover
				content={confirmText}
				hoverText={hoverText}
				onConfirm={onConfirm || this.handleConfirmDelete}
				placement={placement}
				buttonStyle={{
					fontSize: '12px',
					padding: '0 .5vw',
					height: '24px',
					marginBottom: '.5vw',
				}}
			>
				{header ? (
					<HeaderButton {...extraButtonProps} size="small">
						{children}
					</HeaderButton>
				) : (
					<Button ghost="true" shape={shape} {...buttonProps} {...extraButtonProps} style={style}>
						{children}
					</Button>
				)}
			</Popover>
		);
	}
}

const msp = state => ({
	socket: state.ws.socket,
	auth0Token: state.auth.auth0Token,
});
export default connect(msp, null)(DeleteButton);
